import { useAutoAnimate } from "@formkit/auto-animate/react";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Head from "next/head";
import Link from "next/link";
import { useEffect, useState } from "react";
import useSWR from "swr";
import ContentNotFound from "../../components/ContentNotFound";
import Layout from "../../components/layout";
import CelebrityCard from "../../components/Layout/CelebrityCard";
import SEOMeta from "../../components/SEOMeta";
import {
  getAllCelebrity,
  getInnerPageContent,
  resolveAll,
} from "../../lib/api";

export default function celebrity({ initialCelebData, pageData }) {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();

  const [show, setShow] = useState(true);
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [filteredData, setFilteredData] = useState([]);

  const {
    data: celebData,
    isValidating,
    error,
  } = useSWR(`/api/allCeleb`, (url) => getAllCelebrity().then((res) => res));

  async function changeProfession(event) {
    if (event.target.checked) {
      setCheckedItems((current) => [...current, event.target.value]);
    } else {
      setCheckedItems((checkedItems) =>
        checkedItems.filter((item) => item !== event.target.value)
      );
    }
  }

  useEffect(() => {
    const celebArray = celebData ?? initialCelebData;

    const filteredCelebArray = celebArray.filter(
      (celeb) =>
        !checkedItems.length ||
        celeb.node.profession.edges.some((p) =>
          checkedItems.includes(p.node.slug)
        )
    );
    setFilteredData(filteredCelebArray);
  }, [checkedItems]);

  let professions = (initialCelebData as any[]).reduce((old, { node }) => {
    const profs = node.profession.edges.map(({ node }) => node) as any[];
    if (!old.length) return profs;

    const all = [...old];
    profs.forEach((prof) => {
      const alreadyThere = all.some((o) => o.name == prof.name);
      if (!alreadyThere) all.push(prof);
    });
    return all;
  }, []);

  //console.log({ professions });

  return (
    <Layout>
      <Head>
        <title>{pageData[0].seo.title}</title>
        <SEOMeta seoData={pageData[0].seo} type="celebsListing" desc="Gossipment is a leading source of reliable Blogs, news and guides. Get hard-to-find insights and advice on Blogs from industry-specific experts."/>
      </Head>

      <header className="celebrity-banner">
        <div className="celebrity-banner-overlay">
          <h2 className="title">{pageData[0].title}</h2>
        </div>
        <div
          className="celebrity-banner-wrapper"
          dangerouslySetInnerHTML={{ __html: pageData[0].content }}
        />
      </header>

      <section className="celebrity-card-sec mt-5 mb-5">
        <section
          className={
            !show ? "filter-wrapper-show filter-wrapper" : "filter-wrapper"
          }
        >
          <span className="cross-wraper" onClick={() => setShow(!show)}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </span>
          <h3> Professions</h3>
          <ul>
            {professions.map((node) => (
              <li>
                <Link href={`${node.uri}`}>
                  <a>{node.name}</a>
                </Link>
              </li>
            ))}
          </ul>
        </section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card-chip-whapper">
                <div className="card-chip-left">
                  {professions.map((node) => (
                    <>
                      <input
                        className="form-check-input d-none"
                        type="checkbox"
                        name={`chip-${node.slug}`}
                        id={`chip-${node.slug}`}
                        value={node.slug}
                        onChange={changeProfession}
                        data-prof={node.slug}
                      />
                      <label
                        htmlFor={`chip-${node.slug}`}
                        style={{ cursor: "pointer" }}
                      >
                        <span
                          className="chip-card"
                          style={{ userSelect: "none" }}
                        >
                          <FontAwesomeIcon icon={faCheckCircle} />
                          {node.name}
                        </span>
                      </label>
                    </>
                  ))}
                </div>
                {/* <div className="card-chip-right">
                  <button
                    type="button"
                    id="#"
                    className="c-btn filter btn-outline-primary"
                    onClick={() => setShow(!show)}
                  >
                    <FontAwesomeIcon icon={faArrowDownWideShort} />
                  </button>
                </div> */}
              </div>
            </div>
            <div className="col-md-12">
              <div
                ref={animationParent}
                className="celebrity-sec-card-whapper mt-5"
                style={{ minHeight: "500px" }}
              >
                {/* {!filteredData && !isValidating &&  (
                  <ContentNotFound text={"No Celebrity found!!"} />
                )}           */}
                {checkedItems && filteredData.length <= 0 && !isValidating && (
                  <ContentNotFound text={"No Celebrity found!!"} />
                )}

                {filteredData?.map(({ node }) => (
                  <CelebrityCard key={node.slug} data={node} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export async function getStaticProps({ params, preview = false }) {
  const slug = "Celebrity";
  const [innerPageData, allCeleb] = await resolveAll([
    getInnerPageContent(slug, preview),
    getAllCelebrity(),
  ]);

  return {
    props: {
      preview,
      pageData: innerPageData.nodes,
      initialCelebData: allCeleb,
    },
    revalidate: 60 * 60 * 24,
  };
}
